import { pathOr } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useModalData } from '../../../components/modals/ModalsContext'
import { useRemoveColumn } from './_requests/removeCol'
import { useSaveScreen } from './_requests/saveScreen'
import { useScreen } from './_load/ScreenLoader'
import Button from '../../../packages/kiti/components/actions/Button'
import Form from '../../../packages/kiti/components/form/form/Form'
import GeneralSection from './sections/GeneralSection'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'

const EditScreenForm = () => {
  const { index } = useModalData() || {}
  const screen = useScreen()
  const [onSubmit, { loading, error }] = useSaveScreen()
  const [onRemove, { loading: loadingRemove }] = useRemoveColumn()
  const column = pathOr({ color: 'light5' }, ['data', 'columns', index], screen)
  const { t } = useTranslation('common')

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={column}>
      <GeneralSection />
      <SubmitBar loading={loading} error={error}>
        {index >= 0 && (
          <Button color="red" transparent onClick={onRemove} loading={loadingRemove || loading}>
            {t('remove')}
          </Button>
        )}
      </SubmitBar>
    </Form>
  )
}

export default EditScreenForm
